import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface Search extends SVGProps<SVGSVGElement> {
  label?: string
}

const Search: React.FC<Search> = ({ label = 'search', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="search-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.867 18 18 14.867 18 11C18 7.132 14.867 4 11 4C7.132 4 4 7.132 4 11C4 14.867 7.132 18 11 18ZM19.485 18.071L22.314 20.899L20.899 22.314L18.071 19.485L19.485 18.071Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default Search
